var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17221 1.59626L9.17218 1.59628L2.33363 7.81969H3.10444V16.969V16.9791L3.10417 16.9892C3.09992 17.1467 3.14609 17.4143 3.28815 17.6319C3.40547 17.8117 3.60437 17.9891 4.01265 18.0303H5.9805V9.72403V8.97403H6.7305H12.3696H13.1196V9.72403V18.0303H15.4372C15.5619 18.0303 15.7656 17.9931 15.9202 17.9019C15.9905 17.8605 16.0373 17.8159 16.0677 17.7712C16.0935 17.7332 16.1203 17.6768 16.1308 17.5848V7.81969H16.6829C15.6104 6.8401 14.3554 5.69749 13.2063 4.65823C11.5174 3.13094 10.1052 1.87118 9.79589 1.63657C9.6166 1.50057 9.48277 1.49376 9.39381 1.50586C9.34063 1.51309 9.29023 1.5296 9.24678 1.55048C9.22538 1.56076 9.20754 1.57121 9.19383 1.58031C9.18706 1.5848 9.18176 1.58866 9.17793 1.59162L9.1736 1.59507L9.17254 1.59597L9.17221 1.59626ZM11.6196 18.0303V10.474H7.4805V18.0303H11.6196ZM1.00959 9.02463L1.60444 8.48329V16.96C1.59577 17.3594 1.69527 17.9358 2.03201 18.4518C2.39397 19.0063 3.00818 19.4519 3.91611 19.5277L3.94725 19.5303H3.9785H15.4372C15.7636 19.5303 16.2455 19.4514 16.6819 19.1942C17.1494 18.9186 17.5702 18.4277 17.6285 17.6773L17.6308 17.6483V17.6192V8.68642L17.9981 9.02285L19.0115 7.91703C17.7777 6.78621 15.8839 5.05733 14.2124 3.54569C12.5614 2.05263 11.0789 0.72705 10.7024 0.441501L10.2492 1.03903L10.7024 0.441501C9.63928 -0.36497 8.58174 0.1093 8.16824 0.481786L8.16823 0.481779L8.16541 0.484342L0 7.91525L1.00959 9.02463Z",
    fill: "#202124"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50488 8.25171L9.50488 0.751709L17.0049 7.75171L16.5049 18.7517L3.00488 18.2517L2.50488 8.75171L1.50488 8.25171ZM11.5049 17.7517V10.7517H7.50488V17.7517H11.5049Z",
    fill: "#202124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/home-filled.945615abe862fcdd0114579f2b0fa23a.svg";
export { ForwardRef as ReactComponent };